import {NavigationEnd, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {ParticleConfig} from '../../features/particle-config';


import { SecurityState } from '@shared/store/reducers/security.reducer';
import { getUserInfo } from '@shared/store/selectors/security.selector';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CommandService} from "./command.service";
import {AcknowledgeTabChangeCommand} from "@shared/commands/dashboard.command";

@Injectable()
export class AnalyticsService {
  constructor( private router: Router,
               private securityStore: Store<SecurityState>,
               private httpClient: HttpClient,
               private commandService : CommandService) {
    //this.initMatomo();
    //this.initRouteChangeListener();
    //this.initUserInfoListener();
  }

  initMatomo() {
    window['_paq'] = window['_paq'] || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    window['_paq'].push(['setDocumentTitle', document.domain + '/' + document.title]);
    window['_paq'].push(['setCookieDomain', '*.localhost']);
    // you can set up to 5 custom variables for each visitor
    window['_paq'].push(['setCustomVariable', 1, '', '', 'visit']);
    window['_paq'].push(['disableCookies']);
    window['_paq'].push(['trackPageView']);
    window['_paq'].push(['enableLinkTracking']);
    window['_paq'].push(['setTrackerUrl', ParticleConfig.MatomoAnalyticsUrlApi + 'piwik.php']);
    window['_paq'].push(['setSiteId', ParticleConfig.MatomoAnalyticsIdApi]);
    const d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript'; g.async = true; g.defer = true; g.src = ParticleConfig.MatomoAnalyticsUrlApi + 'piwik.js'; s.parentNode.insertBefore(g, s);

  }

  initRouteChangeListener() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        window['_paq'].push(['setCustomUrl', val.urlAfterRedirects]);
        window['_paq'].push(['trackPageView']);
      }
    });
  }

  initUserInfoListener() {
    window['_paq'] = window['_paq'] || [];
    this.securityStore.select(getUserInfo).subscribe(userInfo => {
      if (userInfo && userInfo.userName && userInfo.companyId) {
        console.log(userInfo);
        window['_paq'].push(['setUserId', userInfo.companyId + '/' + userInfo.userName]);
        window['_paq'].push(['trackPageView']);
      }
    });
  }
  refreashReport(payload: any){
    return this.httpClient.post<any>( ParticleConfig.RefreashAnalyticReportApiKey, payload );
  }
  getAnalyticLoadingStatus(){
    return this.httpClient.get<any>(ParticleConfig.AnalyticLoadingStatusApiKey);
  }
  getSolutionName(analyticsType : string){
    switch (analyticsType){
      case 'EntityChart' :
        return 'Project Settings';
      case 'Law Changes' :
        return 'Change Reports Tracker';
      case 'Due Dates':
        return 'Due Date Tracker';
      case 'Entity Change Report' :
        return 'Entity Tracker';
      case 'Tax News':
        return 'International Tax Research and Compliance Expert';
      default:
        return '';
    }
  }
  postAcknowledgeTabChangeCommand(solutionName: string,tabName: string, reportId: string){
    var trackPageCommand = new AcknowledgeTabChangeCommand(solutionName,tabName,reportId);
    this.commandService.executeCommand(trackPageCommand);
  }
}
